<template>
<div>
<div class="modal" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header p-2">
        <h6 class="modal-title">{{isPoolCatalogMapper?'Catalog-Pool Mapper':'Pool Group'}}</h6>
        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" v-on:click="closeGroupDialog(false)">
          <span aria-hidden="true"><cancel-icon class="close-icon" style="height: 30px !important;
    width: 30px !important;
    color: #fff;"></cancel-icon></span>
        </button>
      </div>
      <div class="modal-body">
          <div v-if="!isPoolCatalogMapper" class="common-input-field w-100" style="margin-top:7px;">
            <div>
                <label>{{$t('Pool Group Name')}} <span style="font-size: 15px">*</span></label>
            </div>
            <div class="value-div d-inline-flex">
                <input
                    minlength="3"
                    type="text"
                    class="bg-transparent border input-text-field rounded text-light w-100 pt-1"
                    v-model="poolGroupName"
                    autocomplete="off"
                    id="pool_group_name"
                    placeholder="Enter pool group name"
                    style="padding-inline-start:5px;"
                  />
            </div>
            <!-- <div v-if="isEditMode" class="value-div d-inline-flex float-left" style="padding-inline-start:0px !important">
              <div class="w-100 d-inline-flex">
                <div class="d-inline-flex group-name">
                  <span v-show="!isEditGroupName" style="padding-top: 3px;
  padding-inline-start: 8px;font-size: 16px;">{{
                    poolGroupName
                  }}</span>
                  <edit-icon
                    @click.native="openEditModeOfGroupName()"
                    v-show="!isEditGroupName"
                    class="editIcon"
                  ></edit-icon>
                </div>
                <input
                    minlength="3"
                    type="text"
                    v-model="poolGroupName"
                    v-show="isEditGroupName"
                    class="rounded text-light comm-input-field-style"
                    id="input_field_focus"
                    required
                    style="padding-inline-start:5px;"
                    v-on:keyup.enter="updateGroupName()"
                  />
                  <div v-show="isEditGroupName">
                    <div class="d-flex" style="padding-top: 9px;">
                      <save-icon
                        @click.native="updateGroupName()"
                      ></save-icon>
                      <cancel-icon @click.native="isEditGroupName = false"></cancel-icon>
                    </div>
                  </div>
              </div>
            </div> -->
          </div>
          <div v-if="isPoolCatalogMapper" class="common-input-field w-100" style="margin-top:7px;">
            <label>{{$t('Catalog')}} <span style="font-size: 15px">*</span></label>
            <div style="flex: 1;display: flex; flex-direction: column; justify-content: center;">
              <div class="search-bar-comm-style" style="display: inline-flex;">
                <catalog-dropdown 
                  :selectedOptions="selectedCatalogsArr" 
                  @updatedCatalogsList="updatedCatalogsList" 
                  :allowSingleSelect="true"
                  :allowSingleSelectFromBrowse="true"
                  :enableCatBrowser="true" style="width:100%;margin-inline-end: 6px;"></catalog-dropdown>
                </div>
            </div>
          </div>
          <div class="w-100 common-input-field" style="margin-top:7px;">
            <div>
                <label>{{$t('Select pools')}} <span style="font-size: 15px">*</span></label>
            </div>
            <ul class="tags-display-ul p-0 active-tag" style="margin-top: 1px;margin-inline-start:5px">
              <template v-for="pool in poolsArr">
                <li v-if="!pool.is_group" :key="pool.pool_id"
                  @click="selectPoolId(pool.pool_id)"
                  :class="{activePool: getPoolIdList.includes(pool.pool_id) }" class='view-tags'>
                  <span>{{pool.pool_name}}</span>
                </li>
              </template>
            </ul>
          </div>
           <!-- <div v-if="isPoolCatalogMapper" class="common-input-field w-100" style="display: flex;justify-content: flex-start;margin-top:7px">
              <label style="width:25%">{{$t('Apply Recursively')}}</label>
              <div class="search-bar-comm-style">
                  <div class="custom-control custom-switch">
                      <input
                          v-on:click="updateApplyRecursivley($event.target.checked)"
                          type="checkbox"
                          class="custom-control-input"
                          id="customSwitch1"
                          :checked='selectedCatalogPoolMapperInfo && selectedCatalogPoolMapperInfo.apply_recursively?selectedCatalogPoolMapperInfo.apply_recursively:false'/>
                      <label class="custom-control-label" for="customSwitch1"></label>
                  </div>
              </div>
          </div> -->
      </div>
        <div class="modal-footer p-0 primary-btn-style">
            <div>
                <button class="btn btn-outline-secondary mr-3" data-dismiss="modal" @click="closeGroupDialog(false)">{{$t('Cancel')}}</button>
                <button class="btn btn-outline-primary ml-1 mr-2" @click="addOrEditPoolsToGroup()">{{$t('Save')}}</button>
            </div>
        </div>
    </div>
  </div>
</div>
</div>
</template>

<script>
import {mapActions} from "vuex";
import cancelIcon from "../core/InlineCancelField.vue"
import Utils from "../../components.utils.js";
// import EditIcon from "../core/InlineEditField.vue";
// import SaveIcon from "../core/InlineSaveField.vue";
import catalogDropdown from "../categories/CatalogMultiselectDropdown.vue";

export default {
    props:['isEditMode','selectedPoolGroupInfo','poolsArr','isPoolCatalogMapper',"selectedCatalogPoolMapperInfo"],
    data(){
        return{
            poolIdList:[],
            poolGroupName:null,
            isEditGroupName:false,
            poolGroupId:null,
            selectedCatalog:null,
            selectedCatalogsArr:null,
            applyRecursively:false
        };
    },
    components:{
      // "edit-icon": EditIcon,
      // "save-icon": SaveIcon,
      'cancel-icon':cancelIcon,
      'catalog-dropdown':catalogDropdown
    },
    computed:{
      getPoolIdList(){
        return this.poolIdList;
      }
    },
    methods:{
      updateApplyRecursivley(val){
        this.applyRecursively = val;
      },
        updatedCatalogsList(option){
          this.selectedCatalog = option.parent_id_path[0]+ "/" + option._id;
        },
        addOrEditPoolsToGroup(){
          let payload = {};
          if(!this.isPoolCatalogMapper){
            if(!this.poolGroupName){
              alert("Pool group name is empty");
              return false;
            }
            if(!this.poolIdList.length){
              alert("Select atleast one pool name");
              return false;
            }
            payload = {
              "pool_group_name":this.poolGroupName,
              "pool_ids":this.poolIdList
            };
          }else{
            if(!this.poolIdList.length){
              alert("Select atleast one pool name");
              return false;
            }
            if(!this.selectedCatalog){
              alert("Select Catalog");
              return false;
            }
            payload = {
              "catalog_id_path":this.selectedCatalog,
              "pool_ids":this.poolIdList,
              // "apply_recursively":this.applyRecursively
            };
          }
          if(this.isEditMode){
            if(this.isPoolCatalogMapper){
              payload["id"] = this.selectedCatalogPoolMapperInfo.id;
              this.editCatalogPoolMapper(payload).then((data)=>{
                if (Utils.isAcceptedStatusCode(data.statusCode)) {
                    this.$toast.success(data.message);
                    this.closeGroupDialog(true);
                } else {
                    this.$toast.error(data.message);
                }
              }) 
            }else{
                payload["id"] = this.poolGroupId;
                this.editPoolGroup(payload).then((data)=>{
                if (Utils.isAcceptedStatusCode(data.statusCode)) {
                    this.$toast.success(data.message);
                    this.closeGroupDialog(true);
                } else {
                    this.$toast.error(data.message);
                }
              })
            }
          }else{
            if(this.isPoolCatalogMapper){
              this.createCatalogPoolMapper(payload).then((data)=>{
                if (Utils.isAcceptedStatusCode(data.statusCode)) {
                    this.$toast.success(data.message);
                    this.closeGroupDialog(true);
                } else {
                    this.$toast.error(data.message);
                }
              })
            }else{
                this.createPoolGroup(payload).then((data)=>{
                if (Utils.isAcceptedStatusCode(data.statusCode)) {
                    this.$toast.success(data.message);
                    this.closeGroupDialog(true);
                } else {
                    this.$toast.error(data.message);
                }
              })
            }
          }
        },
        closeGroupDialog(doGet){
          this.$emit("closeDialog",doGet)
        },
        selectPoolId(id){
          if(!this.poolIdList.includes(id)){
            this.poolIdList.push(id)
          }else{
            this.poolIdList = this.poolIdList.filter(e => e != id)
          }
          console.log("this.poolIdList",this.poolIdList)
        },
        openEditModeOfGroupName(){
          this.isEditGroupName = true;
        },
        getOnlyIds(poolInfo){
          for(let t = 0;t < poolInfo.length; t++){
            this.selectPoolId(poolInfo[t].pool_id);
          }
        },
        ...mapActions("pools",["getFusionPools","updateDefaultPool","createPoolGroup","getAllPoolGroups","editPoolGroup","deletePoolGroup","editCatalogPoolMapper","createCatalogPoolMapper"]),
    },
    created(){
      if(this.isEditMode && this.selectedPoolGroupInfo.groupname){
        this.poolIdList = [];
        this.poolGroupName = this.selectedPoolGroupInfo.groupname
        if(this.selectedPoolGroupInfo.groupinfo){
          for(let j = 0; j< this.selectedPoolGroupInfo.groupinfo.length;j++){
            this.selectPoolId(this.selectedPoolGroupInfo.groupinfo[j].pool_id)
          }
        }
        if(this.selectedPoolGroupInfo.groupID){
          this.poolGroupId = this.selectedPoolGroupInfo.groupID;
        }
      }
      if(this.isEditMode && this.selectedCatalogPoolMapperInfo){
        this.poolIdList = [];
        if(Object.keys(this.selectedCatalogPoolMapperInfo).includes("catalog_id_path")){
          this.selectedCatalogPoolMapperInfo.catalog_id_path = [this.selectedCatalogPoolMapperInfo.catalog_id_path];
          this.selectedCatalog = this.selectedCatalogPoolMapperInfo.catalog_id_path[0];
        }
        if(Object.keys(this.selectedCatalogPoolMapperInfo).includes("catalog_name_path")){
          this.selectedCatalogPoolMapperInfo["catalog_name"] = this.selectedCatalogPoolMapperInfo.catalog_name_path.split("/")[this.selectedCatalogPoolMapperInfo.catalog_name_path.split("/").length - 1];
        }
        // if(Object.keys(this.selectedCatalogPoolMapperInfo).includes("apply_recursively")){
        //   this.applyRecursively = this.selectedCatalogPoolMapperInfo.apply_recursively;
        // }
        this.selectedCatalogsArr = this.selectedCatalogPoolMapperInfo;
        this.getOnlyIds(this.selectedCatalogPoolMapperInfo.pool_ids)
      }
    },
    mounted(){
      if(!this.isEditMode){
        if(parent.document.getElementById("pool_group_name"))parent.document.getElementById("pool_group_name").focus();
      }
    }
}
</script>

<style scoped lang="scss">
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;


.common-input-field{
    margin-inline-start: 0px;
    display: inline-block;
    width: 96%;
    justify-content: space-between;
    display: inline-block;
    padding: 9px;
    border-radius: 4px;
    background: $primary-background;
    border: $secondary-border-color !important;
    padding-bottom:22px;
    label{
        width: 30%;
        color: $secondary-text-color;
        word-break: break-word;
    }
    input{
        flex:1;
    }
}
.input-text-field{
    height: 44px;
    width: 100% !important;
    padding-inline-start: 2%;
    padding-inline-end:2%;
    overflow: hidden;
}

.modal-dialog {
    max-width: 500px;
    width: 500px;
    height: 450px;
    margin: 0;
    padding: 0;
  }
  
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      height: 300px;
      overflow: auto;
      padding:10px;
    }
  }

.modal {
    text-align: center;
    padding: 0 !important;
    display: block;
    position: fixed;
    inset-inline-start: 0px;
    top: 20%;
}
.modal:before {
    content: "";
    display: inline-block;
    height: 100vh;
    vertical-align: middle;
    margin-inline-end: -4px;
    position: fixed;
    width: 100vw;
    inset-inline-start: 0;
    top: 0;
    background: #00000094;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:14px !important;
    height:100%;
}

.search-bar{
  background: $primary-background!important;
  height:40px;
  width: 250px !important;
  float: inline-start;
  padding-inline-start: 12px;
  padding-bottom: 2px;
  border:$border-color !important;
}

.height-set{
  height: calc(100vh - 170px);
  background: $primary-background;
  .group-name{
    text-align: start;
    padding:16px 3%;
    font-size:27px;
    display:flex;
  }
  .group-members{
    height: calc(100% - 90px);
    cursor: pointer;
  }
}

.add-user-icon-wrapper{
    height: 59px;
    width: 60px;
    line-height: 54px;
    border-radius: 6px;
    background: $primary-background;
    color: $add-button-text-color;
    border: 1px solid $add-button-border-color; 
    display:flex;
    svg{
      margin:auto;
    }
}

.add-user-icon-wrapper:hover{
    color: $add-button-text-color-hover;
    border: 1px solid $add-button-border-on-hover; 
}

.editIcon {
    margin-inline-start: 9px;
    margin-top: 0px
}

.comm-input-field-style{
    background: $primary-background!important;
    height:40px;
    width: 100% !important;
    float: inline-start;
    padding-inline-start: 12px;
    padding-bottom: 2px;
    border: $border-color!important;
}

.search-bar-comm-style{
  padding-inline-start:3%;
  height:60px;
}

#contact_number_input::-webkit-outer-spin-button,
#contact_number_input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.close-icon:hover{
  background: #373737;
  border-radius: 20px;
}

  .key-div {
    text-align: end;
    color: $dull-text-color;
  }
  .value-div {
    text-align: start;
    margin-inline-start: 7px;
    width: 100%;
    font-weight: 500;
    input,select{
      padding-inline-start:4px;
    }
  }

.activeTag{
    color: $active-blue !important;
}

.activeclass {
  color: $active-blue;
}

table {
  background: transparent;
  thead {
    th {
      color: $dull-text-color;
      border-top: none !important;
      border-bottom: none !important;
    }
  }
  tbody {
    color: $text-color;
    td {
      border-top: none !important;
    }
  }
}

.btn {
  font-size: $input-field-and-label-font-size !important;
  height: 100%;
}

.custom-control-label::before {
  background-color: $primary-background;
}

table.users-basic-info-table .editIcon {
  visibility: hidden;
}
table.users-basic-info-table td.value-div:hover .editIcon {
  visibility: visible;
}

.disablefield {
  border: none !important;
  pointer-events: none;
}

.force-logout {
  position: relative;
  inset-inline-start: 5px;
  bottom: 4px;
}
.force-logout:hover {
  text-decoration: underline;
}
.activestatus {
  color: $active-green-color !important;
}
.validationmessage {
  color: $danger-color;
  font-size: 11px;
}

.nav-item{
    color: $dull-text-color !important;
}

.active{
    background: $primary-background !important;
    color: $text-color !important;
}
.top-nav-bar{
    background: $primary-background;
}

.tags-display-ul .show-tags-delete{
  visibility:hidden;
}

.tags-display-ul li:hover .show-tags-delete{
  visibility: visible;
}

.editIcon{
  visibility:hidden;
}

.group-name:hover .editIcon{
  visibility: visible;
}

.show-tags-delete{
  position: relative;
  top: 2px;
}

.breadcrumb{
  padding: .75rem 1rem !important;
  background: $primary-background !important;
    .active-text-nav-bar{
        color: $text-color !important;
        text-decoration: none !important
    }
    .active-text-nav-bar:last-child{
            color: $active-blue !important;
            font-size:17px;
    }
    .breadcrumb-item{
        a{
            color: $text-color;
            font-weight:600;
        }
        a:hover{
            text-decoration: underline;
        }
    }    
}

.delete-user-icon{
  visibility: hidden;
}

.comm-tags-class:hover .delete-user-icon{
  visibility: visible;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}
.border{
    border: $border-color !important;
}

.activePool{
    color: $active-blue;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    .modal-title{
      color:$text-color;
    }
}

.modal-header .close {
    margin: 0px !important;
    padding: 0px !important;
}

ul{
    list-style-type: none;
}

.primary-btn-style {
  margin-top: 1%;
  height:55px;
  button {
    height: 35px;
    width: 70px;
    border-radius: 5px;
    font-size:14px;
  }
}

.search-bar-comm-style{
  height:30px;
  position:relative;
  input{
    border:$border-color;
    height: 25px;
    padding-inline-start: 6%;
  }
  svg{
    position: absolute;
    inset-inline-start: 21px;
    top: 58%;
  }
}

.secondary-btn-style{
  color:$text-color;
}

.modal-footer{
    justify-content: flex-end;
}

.view-tags {
  font-size:12px!important;
  height: 30px!important;
  display: inline-flex!important;
  margin: 2px!important;
  border: 1px solid $tags-border-color!important;
  border-radius: 15px!important;
  min-width: 50px!important;
  padding: 0!important;
  text-align: center;
  width: auto!important;
  padding-inline-start: 1px!important;
  justify-content: center;
  padding-top: 4px!important;
  background: $tags-background-color;
  span {
    padding: 0px 8px !important;
    margin-inline-start: 0px !important;
    font-size:12px !important;
    border-radius: 15px !important;
    position: relative !important;
    top: 1px !important;
  }
}

.activeTag{
    color: $active-blue !important;
}

.secondary-btn-style:hover{
  text-decoration: underline;
}

.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}

.search-bar-comm-style{
   text-align: center;
   height:auto;
  .search-bar{
    background: $primary-background!important;
    height:42px;
    //width: 180px !important;
    //float: inline-start;
    width:94% !important;
    padding: 0px 12px 0 8px;
    padding-inline-start: 12px;
    border:$border-color !important;
  }
}

::v-deep{
  .multiselect{
        width:100% !important;
        margin: 3px 0px !important;
  }
  .multiselect__content-wrapper{
    display:none;
  }
  .multiselect__tag {
      background-color: $primary-background !important;
    border: $border-color;
      border-radius: 13px;
    }
    .search-bar-comm-style{
        .multiselect__tags{
            background: $primary-background;
            border: $border-color;
            padding-top: 0px;
        }
        .multiselect__tags:hover{
            border:1px solid $icon-hover
        }
        .multiselect__single{
            padding-top:7px !important;
        }
    }
    .multiselect__option--highlight {
        background: $bg-color-on-hover !important;
    }
    .multiselect__content {
        background: $secondary-background-color !important;
    }
    .multiselect__input, .multiselect__single {
        background: transparent !important;
        color:$text-color;
    }
    .multiselect__tag-icon{
       color:$text-color !important;
    }
    .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
        background: $bg-color-on-hover !important;
        color: $text-color !important;
    }
    .multiselect__tag-icon:after{
       color:$icon-hover !important;
       font-size: 23px;
    }

    .multiselect__tag-icon{
      visibility:hidden;
    }

    .multiselect__tag:hover .multiselect__tag-icon{
      visibility:visible;
    }

    .multiselect *{
        font-size: $input-field-and-label-font-size !important;
        font-family: "Roboto", Arial, sans-serif !important;
    }
    .multiselect__placeholder {
      padding-top: 6px;
     }
    .multiselect{
      color:$text-color !important;
      font-size: $input-field-and-label-font-size !important;
      width:28%;
      min-height: 38px;
      height: auto;
    }
    .multiselect__single{
      padding-top:0px !important;
    }
    .multiselect__option--selected{
        background: $bg-color-on-hover !important;
        color: $text-color;
    }
    .multiselect__content-wrapper{
        border: 1px solid $bg-color-on-hover !important;
        position: absolute;
        display: block;
        background: $text-color;
        width: 100% !important;
        max-height: 240px;
        overflow: auto;
        border: 1px solid $text-color;
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        z-index: 50;
        -webkit-overflow-scrolling: touch;
    }
    .multiselect__select,.multiselect__current,.multiselect__option{
        line-height: 12px !important;
    }
    .multiselect--above .multiselect__content-wrapper{
       background: $secondary-background-color !important;
    }
}

</style>